import { render, staticRenderFns } from "./AddBrandModal.vue?vue&type=template&id=e2f01502&scoped=true&"
import script from "./AddBrandModal.vue?vue&type=script&lang=js&"
export * from "./AddBrandModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBrandModal.vue?vue&type=style&index=0&id=e2f01502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f01502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2f01502')) {
      api.createRecord('e2f01502', component.options)
    } else {
      api.reload('e2f01502', component.options)
    }
    module.hot.accept("./AddBrandModal.vue?vue&type=template&id=e2f01502&scoped=true&", function () {
      api.rerender('e2f01502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Brands/AddBrandModal.vue"
export default component.exports